import { MAX_FILE_SIZE, VALIDATION_ERROR_TYPES } from './constants';

export const isValidSize = (file) => file.size <= MAX_FILE_SIZE;
export const isValidType = (file, acceptedFileFormats) =>
  acceptedFileFormats.includes(file.type);

export const validateFile = (file, acceptedFileFormats) => {
  if (!isValidType(file, acceptedFileFormats)) {
    return VALIDATION_ERROR_TYPES.FILE_TYPE;
  }

  if (!isValidSize(file)) {
    return VALIDATION_ERROR_TYPES.FILE_SIZE;
  }
};
